export const VERIFIED = {
    label: 'Verified',
    value: 'VERIFIED'
};
export const REVIEWED = {
    label: 'Reviewed',
    value: 'REVIEWED'
};